
<div class="orders-page">

  <h2>Lista zleceń</h2>

  <!-- Upload pliku -->
  <div class="upload-section">
    <label for="fileUpload" class="upload-button">
      ➕ Dodaj plik z numerami zleceń
    </label>
    <input
      id="fileUpload"
      type="file"
      accept=".txt"
      (change)="onFileSelected($event)"
      hidden
    />
  </div>
  <button (click)="GetAllOrders()">
    Wczytaj z bazy
  </button>
  <!-- Tabela -->
   <ng-container *ngIf="inspector.orders.length > 0">
    <div>Wczytanych {{inspector.orders.length}} zleceń</div>
    <table>
        <thead>
        <tr>
            <th>Nr zlecenia</th>
            <th>Status</th>
            <th>Status opis</th>
            <th>Czas (stara tech)</th>
            <th>Czas (nowa tech)</th>
            <th>Uwagi</th>
            <th>Szczegóły</th>
            <th>Parametry (stara tech)</th>
            <th>Parametry (nowa tech)</th>
            <th>Różnice parametrów</th>
            <th>Czyść dane</th>
            <th>Usuń</th> 

        </tr>
        </thead>

        <tbody>
        <ng-container  *ngFor="let order of inspector.orders; let i = index;">
            <tr *ngIf = "order.status != 'Nowe' && i > ((page - 1) * 20) && i < (page * 20) ">
                        <td>{{ order.orderNumber }}</td>
                        <td>{{ order.status }}</td>
                        <td>{{ order.statusDes }}</td>
                        <td>{{ formatMs(order.oldTechTime) }}</td>
                        <td>{{ formatMs(order.newTechTime) }}</td>
                        <td>{{ order.notes }}</td>
                        <td><span (click) = "showObj(i)">{{ order.details }}</span></td>
                        <td><span *ngIf = "order.oldTechParams != null" (click) = "showParamsS(i)">Zobacz</span></td>
                        <td><span *ngIf = "order.newTechParams != null" (click) = "showParamsN(i)">Zobacz</span></td>
                        <td><span *ngIf = "order.ParamsDif != null && order.ParamsDif != '' && order.ParamsDif != '[]' && order.ParamsDif.length > 0" (click) = "showParamsDif(i)">Zobacz</span></td>
                        <td class="clean-cell">
                <button
                    class="clean-btn"
                    (click)="clearOrderData(i)"
                    title="Wyczyść dane zlecenia">
                    🧹
                </button>
                </td>

                        <td class="delete-cell">
                <button
                    class="delete-btn"
                    (click)="removeOrder(i)"
                    title="Usuń zlecenie"
                >
                    ✖
                </button>
                </td>

            </tr>
        </ng-container>
        
        </tbody>
    </table>
   </ng-container>


  <p *ngIf="inspector.orders.length === 0">
    Brak zleceń – wgraj plik tekstowy.
  </p>
<div><span class="prev"  *ngIf ="page > 1" (click) = "page=page-1">poprzednia</span>{{page}}<span class="next" (click) = "page=page+1">następna</span></div>

<div *ngIf="inspector.orders.length !== 0" class="open-tabs-section">
  <label>
    Liczba nowych kart:
    <input
      type="number"
      min="1"
      [(ngModel)]="openCount"
    />
  </label>

  <button (click)="openNewTabs()">
    Rozpocznij testy
  </button>
  

</div>

<div class="storage-actions" *ngIf="inspector.orders.length !== 0" >
  <button class="danger" (click)="clearOrders()">Wyczyść</button>
</div>

</div>
